import styles from "./BottomBar.module.css";
import { useState, useEffect, useRef } from "react";
import StatusUpdate from "../../Components/StatusUpdate/StatusUpdate";
import TextZoomControls from "../../Components/TextZoomControls/TextZoomControls";
import LoginStatus from "../../Components/User/LoginStatus/LoginStatus";
import CardPrimary from "../../UI/Cards/CardPrimary/CardPrimary";
import SubscribeCTA from "../SubscribeCTA/SubscribeCTA";

const BottomBar = (props) => {
  const user = false;
  const [toggleLoginModal, setToggleLoginModal] = useState(false);
  const barRef = useRef(null);

  /*
    Mobile browsers treat a slight finger move on a bottom control as a page
    pan / chrome-reveal. Block touchmove that starts on the dock so Join stays
    a tap. ROLLBACK: delete this effect.
  */
  useEffect(() => {
    const el = barRef.current;
    if (!el) return undefined;
    const stopPagePan = (e) => {
      e.preventDefault();
    };
    el.addEventListener("touchmove", stopPagePan, { passive: false });
    return () => {
      el.removeEventListener("touchmove", stopPagePan);
    };
  }, []);

  const toggleLoginModalButtonHandler = () => {
    setToggleLoginModal(!toggleLoginModal);
  };

  const loginModalToggleStyles = toggleLoginModal
    ? { opacity: "1", pointerEvents: "all", left: "0" }
    : {};

  return (
    <div ref={barRef} className={styles["bottom-bar"]}>
      <div className={styles["subscribe-cta-wrap"]}>
        <SubscribeCTA layout="compact" submitLabel="Join" revealOnClick />
      </div>
      {false && <StatusUpdate />}
      {props.showLogin && user && (
        <p>
          Login Status: {user.userName ? user.userName : user.email} is
          currently logged in. &nbsp;&nbsp;
          <button
            onClick={toggleLoginModalButtonHandler}
            className={styles["login-bar-button"]}
          >
            LOGOUT
            <span className={styles["right-arrow"]}>&#x2192;</span>
          </button>
        </p>
      )}
      {props.showLogin && !user && (
        <p>
          <span className={styles["not-logged-in"]}>
            No one is logged in.
            <button
              onClick={toggleLoginModalButtonHandler}
              className={styles["login-bar-button"]}
            >
              {" "}
              LOGIN or REGISTER HERE
              <span className={styles["right-arrow"]}>&#x2192;</span>
            </button>
          </span>
        </p>
      )}
      {false && <TextZoomControls />}
      {/*
        Only mount LoginStatus when the modal is open. Keeping email/password
        inputs in the DOM (even opacity:0) makes browsers offer password tools
        on every page that uses BottomBar (e.g. Home).
      */}
      {toggleLoginModal && (
        <div className={styles["login-modal"]} style={loginModalToggleStyles}>
          <CardPrimary>
            <LoginStatus />
            <button onClick={toggleLoginModalButtonHandler}>Close</button>
            <StatusUpdate />
          </CardPrimary>
        </div>
      )}
    </div>
  );
};

export default BottomBar;
